// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./redux/store";

// Browser wallet extensions (e.g. MetaMask) inject scripts into every page and
// throw "Failed to connect to MetaMask" rejections. CRA's dev error overlay
// catches any unhandled rejection and shows a full-screen red box, even though
// these have nothing to do with this app. Swallow them before the overlay sees
// them. Runs only in development; production builds have no overlay anyway.
const isExtensionNoise = (text: string) =>
  /metamask|inpage\.js|contentscript\.js|chrome-extension:\/\/|Receiving end does not exist/i.test(
    text,
  );

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reason: any = event.reason;
    const message =
      typeof reason === "string"
        ? reason
        : reason?.message || reason?.stack || "";
    if (isExtensionNoise(message)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true,
);

window.addEventListener(
  "error",
  (event) => {
    const text = `${event.message || ""} ${event.filename || ""}`;
    if (isExtensionNoise(text)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true,
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
